import { HTTP } from '@/services/axios';

export async function getCampaigns({filterText,filterType,orderCol,orderSort,page,records}){
    let result = {};
    
    await HTTP.get('/app/customMailing/MailingCampaigns/getCampaignList.php',{
        params:{
            filterText,
            filterType,
            orderCol,
            orderSort,
            page,
            records
        }
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function getCampaign({campaignId}){
    let result = {};
   
    await HTTP({
        method: 'get',
        url: `/app/customMailing/MailingCampaigns/getCampaignData.php?campaignId=${campaignId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });
    return result;
}

// zatial nevyuzite
export async function getCampaignOptions(){
    let result = [];
    
    await HTTP.get('/app/customMailing/MailingCampaigns/getCampaignOptions.php',{})
    .then(response => {
        result = response.data.result;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function getCampaignTypeOptions(){
    let result = [];
    
    await HTTP.get('/app/customMailing/MailingCampaigns/getCampaignTypeOptions.php',{})
    .then(response => {
        result = response.data.result;  
    })
        .catch(function (error) {
        console.log(error);
    });

    return result;
}

export async function unlockCampaign(campaignId){
    let result = {};

    var data = {'campaignId':campaignId}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingCampaigns/controlCampaignUnlock.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function changeStateCampaign({recordId,state}){
    let result = {};

    var data = {'recordId':recordId,'state':state}
    
    await HTTP({
        method: 'patch',
        url: '/app/customMailing/MailingCampaigns/controlCampaignChangeState.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function createCampaign({data}){
    let result = {};
   
    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingCampaigns/controlCampaignSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function saveCampaign({data}){
    let result = {};
  
    await HTTP({
        method: 'put',
        url: '/app/customMailing/MailingCampaigns/controlCampaignSave.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function deleteCampaign({data}){
    let result = {};

    await HTTP({
        method: 'delete',
        url: '/app/customMailing/MailingCampaigns/controlCampaignDelete.php',
        data: data
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function loadTemplateData(templateId){
    let result = {};

    await HTTP({
        method: 'get',
        url: `/app/customMailing/MailingCampaigns/loadTemplateDataToPreview.php?templateId=${templateId}`,
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

// send campaign
export async function getContactsToSend({campaignId,optionsCategories}){
    let result = {};
    
    var datas = {'campaignId':campaignId,'myOptionsCategories':optionsCategories}
    
    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingCampaigns/getCampaignContacts.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function sendCampaignSMS({campaignId,optionsCategories}){
    let result = {};

    var datas = {'campaignId':campaignId,'myOptionsCategories':optionsCategories}
    
    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingCampaigns/controlCampaignPlaceSMSToFront.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}

export async function sendCampaignEmail({campaignId,optionsCategories}){
    let result = {};

    var datas = {'campaignId':campaignId,'myOptionsCategories':optionsCategories}
 
    await HTTP({
        method: 'post',
        url: '/app/customMailing/MailingCampaigns/controlCampaignPlaceEmailToFront.php',
        data: datas
    })
    .then(response => {
        result = response.data;  
    })
    .catch(function (error) {
        result={'status':error.response.status,'statusText':error.response.statusText}
    });

    return result;
}